import { createAction, props } from '@ngrx/store';
import { FNA, FNARequest } from '../models/fna.model';

export const loadFNA = createAction('[FNA] Load FNA', props<{ request: FNARequest }>());

export const loadFNASuccess = createAction('[FNA] Load FNA Success', props<{ response: FNA }>());

export const loadFNAFailure = createAction('[FNA] Load FNA Failure', props<{ error: Error | any }>());
